import { generateEmployeeColor } from 'helper/helper';
import { Fragment } from 'react';

const escape = (text) => text.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

/**
 * A comment's text, the colleagues it names (@Prénom Nom) written in the
 * colour of their avatar. `people`: [{ firstname, lastname }].
 */
const MentionText = ({ text, people }) => {
  const names = people.map((person) => `${person.firstname} ${person.lastname}`.trim()).filter(Boolean);
  if (!names.length) return text;
  const parts = text.split(new RegExp(`(@(?:${names.map(escape).join('|')}))`, 'g'));
  return parts.map((part, index) => {
    const person = part.startsWith('@')
      ? people.find((member) => `${member.firstname} ${member.lastname}`.trim() === part.slice(1))
      : null;
    return person ? (
      <span
        key={index}
        className="font-medium"
        style={{ color: generateEmployeeColor(person.firstname, person.lastname) }}
      >
        {part}
      </span>
    ) : (
      <Fragment key={index}>{part}</Fragment>
    );
  });
};

export default MentionText;
